import React, { useEffect, useState } from "react";
import { debounce } from "throttle-debounce";
import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import Select from "react-select";
import { themeColorTitles, themeColorsOptions } from "../models";
import { THEME_COLOR_ACCENT, THEME_COLOR_BACKGROUND, THEME_COLOR_TEXT, THEME_COLOR_THEME, THEME_DARK } from "../constants";
import HelpHintButton from "components/HelpHintButton";
import { updateEventModuleTheme } from "../../../../../api/cp";

const watchPlayerThemesOptions = [
    { value: '000000', label: 'Темная', },
    { value: 'FFFFFF', label: 'Светлая', },
];

const watchPlayerThemeColors = {
    borderColor: 'Цвет границ',
    inactiveColor: 'Цвет неактивного элемента',
    episodeTextColor: 'Цвет текста эпизода',
    episodeBackgroundColor: 'Цвет фона эпизода',
};

const ThemeSettings = ({ event, setEvent, eventTheme, onUpdate }) => {
    const [themeColors, setThemeColors] = useState({});
    const [theme, setTheme] = useState(THEME_DARK);

    useEffect(() => {
        setThemeColors({
            [THEME_COLOR_ACCENT]: eventTheme[THEME_COLOR_ACCENT] || 'FF434C',
            [THEME_COLOR_BACKGROUND]: eventTheme[THEME_COLOR_BACKGROUND] || '16161B',
            [THEME_COLOR_TEXT]: eventTheme[THEME_COLOR_TEXT] || 'FFFFFF',
        });
        setTheme(eventTheme.colorTheme);
    }, []);

    const handleChangeTheme = (value) => {
        const backgroundColor = value === THEME_DARK ? '16161B' : 'FFFFFF';
        const textColor = value === THEME_DARK ? 'FFFFFF' : '16161B';

        setThemeColors({
            ...themeColors,
            [THEME_COLOR_BACKGROUND]: backgroundColor,
            [THEME_COLOR_TEXT]: textColor,
        });

        setTheme(value);
        onUpdate({ [THEME_COLOR_THEME]: value });
    };

    const handleChangeThemeColor = debounce(500, (key, value) => {
        const color = value.replace('#', '');

        setThemeColors({ ...themeColors, [key]: color });
        onUpdate({ [key]: color });
    });

    const handleThemeChange = async (playerBackgroundColor) => {
        const _moduleTheme = {
            ...event.moduleTheme,
            playerBackgroundColor,
            playerTextColor: playerBackgroundColor === '000000' ? 'FFFFFF' : '000000'
        }
        try {
            const moduleTheme = updateEventModuleTheme(event.eventKey, _moduleTheme);
            setEvent(event => ({ ...event, moduleTheme }))
        } catch (e) {
            console.error(e)
        }
    }

    const handleColorChange = debounce(500, (color, hex) => {
        const value = hex.replace('#', '')
        const moduleTheme = {
            ...event.moduleTheme,
            [color]: value
        };
        setEvent(event => ({ ...event, moduleTheme }));
        updateEventModuleTheme(event.eventKey, moduleTheme)
            .then(moduleTheme => setEvent(event => ({ ...event, moduleTheme })))
            .catch(e => console.error(e))
    });

    return (
        <>
            <FormGroup>
                <ControlLabel>
                    <span>
                        Цветовая схема
                        <HelpHintButton>
                            Настройка будет применена ко всем разделам платформы
                        </HelpHintButton>
                    </span>
                </ControlLabel>
                <FormGroup>
                    <FormControl
                        componentClass="select"
                        name="eventTheme"
                        value={theme}
                        onChange={(e) => handleChangeTheme(e.target.value)}
                    >
                        {Object.entries(themeColorTitles).map(([theme, name]) => (
                            <option
                                key={theme}
                                value={theme}
                            >
                                {name}
                            </option>
                        ))}
                    </FormControl>
                </FormGroup>
                {themeColorsOptions.map((color) => (
                    <FormGroup
                        key={color.key}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <input
                            type="color"
                            value={`#${themeColors[color.key]}`}
                            onChange={(e) => handleChangeThemeColor(color.key, e.target.value)}
                        />
                        <span>&nbsp; {color.title}</span>
                    </FormGroup>
                ))}
            </FormGroup>
            {event.moduleMain.frontendPage === 'watch' &&
                <FormGroup >
                    <ControlLabel>Цветовая схема плеера</ControlLabel>
                    <Select
                        value={watchPlayerThemesOptions.find(({ value }) => event.moduleTheme.playerBackgroundColor === value) || watchPlayerThemesOptions[0]}
                        onChange={({ value }) => handleThemeChange(value)}
                        options={watchPlayerThemesOptions}
                    />
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap', marginTop: '1rem' }}>
                        {Object.keys(watchPlayerThemeColors).map(color =>
                            <div key={color} style={{ display: 'flex', flexGrow: 1, flexBasis: '35%', gap: '0.5rem', alignItems: 'center' }}>
                                <input
                                    type="color"
                                    value={`#${event.moduleTheme[color] || 'ffffff'}`}
                                    onChange={(e) => handleColorChange(color, e.target.value)}
                                />
                                <div style={{ marginBottom: '0.5rem' }}>{watchPlayerThemeColors[color]}</div>
                            </div>
                        )}
                    </div>
                </FormGroup>
            }
        </>
    )
};

export default ThemeSettings;
